//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetItemName, GetItemSkinName, conversion } from "@/tool";
import autohue from "autohue.js";
import pictureUrl from "@/assets/images/background1.png";
export default {
  name: "BoxLotteryH",
  props: {
    mpCasesList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    lotteryCount: {
      type: Number,
      default: Number,
    },
    isTransition: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    currentWidth: {
      type: Number,
      default: Number,
    },
    isDefault: {
      type: Boolean,
      default: true,
    },
    isMorePeople: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      run_status: 0,
      animation_end: false,
      pictureUrl,
      isMoreRunning: false,
      virtual_case_awards: [],
    };
  },
  filters: {
    GetItemName,
    GetItemSkinName,
    conversion,
  },
  computed: {},
  beforeDestory() {},
  watch: {
    lotteryCount(e) {
      this.animation_end = false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.virtual_case_awards = [];
      this.mpCasesList.forEach((mpc_item) => {
        this.virtual_case_awards.push(
          this.random_case_awards(mpc_item.case_awards)
        );
        // this.autohueMPCpicture(mpc_item);
      });
    });
  },
  methods: {
    /** 乱序奖品池 */
    random_case_awards(case_awards) {
      // 生成一轮奖品
      var generate_round_awards = (case_awards) =>
        Array(20)
          .fill(null)
          .map(() => case_awards[parseInt(Math.random() * case_awards.length)]);

      return generate_round_awards(case_awards);
    },
    reset() {
      this.virtual_case_awards = [];
      this.mpCasesList.forEach((mpc_item) => {
        this.virtual_case_awards.push(
          this.random_case_awards(mpc_item.case_awards)
        );
      });

      for (var i = 0; i < this.$props.lotteryCount; i++) {
        this.$refs.scroll[i].style.transition = "none";
        this.$refs.scroll[i].style.marginTop = `0px`;
      }

      this.animation_end = false;
      this.run_status = 0;
    },
    async start(lotteryitems) {
      this.reset();
      this.isMoreRunning = true;

      var award_hit_line = this.$refs.hitline;

      for (var i = 0; i < this.$props.lotteryCount; i++) {
        await this.$nextTick();
        this.$set(this.virtual_case_awards[i], 15, lotteryitems[i]); //设置开奖结果
        await this.$nextTick();

        var main_roll = this.$refs.scroll[i];
        var award_opened = this.$refs[`roll_item_${i}_15`][0];

        // console.log(award_opened);

        var move_pixel =
          award_opened.getBoundingClientRect().top -
          award_hit_line.getBoundingClientRect().top -
          award_hit_line.getBoundingClientRect().height / 2;
        var innerHeight = award_opened.getBoundingClientRect().height * 0.9;
        move_pixel += Math.ceil(innerHeight * Math.random());

        var addtime = (3500 + i * 500) / 1000;

        main_roll.style.transition = this.$props.isTransition
          ? "all " + addtime + "s cubic-bezier(.17,.67,.43,1)"
          : "none";
        main_roll.style.marginTop = `${-move_pixel}px`;
      }

      setTimeout(
        () => {
          this.animation_end = true;
          this.$emit("on_finished");
          this.isMoreRunning = false;
        },
        this.$props.isTransition ? 6500 : 100
      );
    },
    autohueMPCpicture(mpc_item) {
      let mpc_item_picture = new Image();
      mpc_item_picture.crossOrigin = "anonymous";
      mpc_item_picture.src = pictureUrl;
      autohue(mpc_item_picture, {
        threshold: {
          primary: 10,
          left: 1,
          bottom: 12,
        },
        maxSize: 50,
      })
        .then((result) => {
          // 使用 console.log 打印出色块元素 s
          console.log(
            `%c${result.primaryColor}`,
            "color: #fff; background: " + result.primaryColor,
            "main"
          );
          console.log(
            `%c${result.secondaryColor}`,
            "color: #fff; background: " + result.secondaryColor,
            "sub"
          );
          console.log(
            `%c${result.backgroundColor.left}`,
            "color: #fff; background: " + result.backgroundColor.left,
            "bg-left"
          );
          console.log(
            `%c${result.backgroundColor.right}`,
            "color: #fff; background: " + result.backgroundColor.right,
            "bg-right"
          );
          console.log(
            `%clinear-gradient to right`,
            "color: #fff; background: linear-gradient(to right, " +
              result.backgroundColor.left +
              ", " +
              result.backgroundColor.right +
              ")",
            "bg"
          );
        })
        .catch((err) => console.error(err));
    },
  },
};
